import { apiEmpleo } from "../../util/ApiEmpleo";
import { TApiCollectionResponse } from "../apiCoreV2.types";
import { TValuationStatus } from "../valuation/valuation.types";
import { TContractState } from "./contract.types";

export interface IApiListCandidateContractsParams {
  candidateId: string;
  page?: number;
  itemsPerPage?: number;
  estado?: string[];
  "order[createdAt]"?: "asc" | "desc";
}

export type TGetCandidateContractsCollectionItem = {
  id: string;
  zohoId?: string;
  Name?: string;
  Estado?: TContractState;
  _Nombre_del_cliente?: string;
  _Tel_fono_cliente?: string;
  Horario_Servicio?: string;
  Fecha_inicio_contrato?: string | null;
  Fecha_de_inicio_real?: string | null;
  Fecha_fin_contrato?: string | null;
  ownerName?: string;
  Tipo_fin_contrato?: string;
  A_ade_nota_del_candidato_a?: string;
  Valoracion_Cuideo_Candidata?: string;
  Compromiso?: number | null;
  Experiencia?: number | null;
  Comunicaci_n?: number | null;
  Paciencia_y_Empatia?: number | null;
  Car_cter?: number | null;
  Valoracion_trabajador?: {
    id: string;
    Estado_en_proceso?: TValuationStatus;
    createdAt?: string;
  } | null;
};

export const apiListCandidateContracts = async ({
  candidateId,
  ...params
}: IApiListCandidateContractsParams) => {
  const res: TApiCollectionResponse<TGetCandidateContractsCollectionItem> =
    await apiEmpleo.get(`candidatos/${candidateId}/contracts`, {
      params,
    });

  return res;
};
